<template>
  <p>{{ loadingText }}</p>
</template>

<script>
export default {
  name: 'EmptyData',
  props: {
    loadingText: {
      type: String,
      default: 'Getting data...',
    },
  },
};
</script>
